import {TranslateService} from '@ngx-translate/core';

export class Payment
{
  id: number;
  accountCd: string;
  createDate: Date;
  paymentDate: Date;
  paymentDateTo: Date;
  paymentMonths: number;
  paymentDays: number;
  paymentStatus: string;
  amount: number;
  methodCd: string;
  typeCd: string;
  invoiceId: number;
  invoiceNr: string;
  pending: boolean;

  vendorCd: string;
  orderId: string;

  date: Date;
  paymentMonthsDays?: string;
  showCustomButton?: boolean;
  rowClass?: string;
  hideDeleteButton?: boolean;

  public static init(item: Payment, translate: TranslateService): void
  {
    if (item)
    {
      if (item.paymentDays > 0)
        item.paymentMonthsDays = item.paymentDays + ' ' + translate.instant(item.paymentDays === 1 ? 'DAY' : 'DAYS');
      else if (item.paymentMonths > 0)
        item.paymentMonthsDays = item.paymentMonths + ' ' + translate.instant(item.paymentMonths === 1 ? 'MONTH' : 'MONTHS');
      else item.paymentMonthsDays = '';

      item.showCustomButton = item.invoiceId > 0;

      if (item.paymentDate)
        item.date = item.paymentDate;
      else item.date = item.createDate;

      if (item.pending)
      {
        item.rowClass = 'text-orange-frontend';
        item.paymentStatus = 'pending';
      }
      if (item.paymentStatus === 'expired')
      {
        item.rowClass = 'frontend-text-gray';
        item.hideDeleteButton = false;
      }
      else item.hideDeleteButton = true;
    }
  }
}
